import ee from 'event-emitter'

export const emitter = ee()
